__turbopack_context__.v({
  "animated": "chevron-module-scss-module__9xAvBW__animated",
  "down": "chevron-module-scss-module__9xAvBW__down",
  "fill-currentColor": "chevron-module-scss-module__9xAvBW__fill-currentColor",
  "fill-step-cold-steel": "chevron-module-scss-module__9xAvBW__fill-step-cold-steel",
  "fill-step-white": "chevron-module-scss-module__9xAvBW__fill-step-white",
  "left": "chevron-module-scss-module__9xAvBW__left",
  "right": "chevron-module-scss-module__9xAvBW__right",
  "up": "chevron-module-scss-module__9xAvBW__up",
});
